export default {"src":"/_next/static/media/checkmark.902c766c.svg","height":16,"width":16};